var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"one-row",attrs:{"id":"main-content"}},[(_vm.loading)?_c('loading-screen'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }